import { createStore } from 'vuex'

export const store = createStore({
  state () {
    return {
      user: false,
      isAuth: false,
      modalSales: [],
      selectContract: null,
      contracts: null,
      profileApiPrefix: '/api/telegram',
    }
  },
  mutations: {
    setUser(state, user){
      state.user = user
    },
    setAuth(state){
      state.isAuth = true
    },
    setModalSales(state, items){
      state.modalSales = items
    },
    setSelectContract(state, item){
      state.selectContract = item
    },
    setContracts(state,items){
      state.contracts = items
    },
    setProfileApiPrefix (state, prefix) {
      state.profileApiPrefix = prefix || '/api/telegram'
    }
  }
})